import axios from 'axios'

const ViolationTypeService = {
  async getList (params = {}) {
    return axios.get('admin/violation-types', { params })
  },

  async show (id) {
    return axios.get(`admin/violation-types/${id}`)
  },

  async store (data) {
    return axios.post('admin/violation-types', data)
  },

  async update (id, data) {
    return axios.put(`admin/violation-types/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/violation-types/${id}`)
  }
}

export default ViolationTypeService
